<template>
  <ui-crud title="Dispatch Dockets" subtitle="Log a record of things leaving Hambro." :fetch="fetch" :pipe-with="pipeItems" groupBy="status">

    <!-- Filters. -->
      <template #filters>
          <div class="relative">
              <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
              <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                  <i class="fas fa-search"></i>
              </div>
          </div>
      </template>

    <!-- List item. -->
    <template #list-item="{ item, select, active }">
      <ui-crud-card
          :title="item.due ? `${item.due}` : '-- No Date --'"
          :subtitle="item.to_string"
          :metadata="`${item.items.length} items`"
          :active="active"
          @click="select()"
      ></ui-crud-card>
    </template>

    <!-- Create form. -->
    <template #create="{ addItem }">
      <dispatch-dockets-form :package-id="packageId" :add-item="addItem"></dispatch-dockets-form>
    </template>

    <!-- Edit form. -->
    <template #edit="{ selectedItem, setEditMode }">
      <dispatch-dockets-form :package-id="packageId" :item="selectedItem" :edit="setEditMode"></dispatch-dockets-form>
    </template>

    <!-- Show page. -->
    <template #show="{ selectedItem, setEditMode, removeItem }">
      <dispatch-dockets-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></dispatch-dockets-show>
    </template>
  </ui-crud>
</template>

<script>
import {DispatchDocket} from '@models'
import UiInput from "../ui/UiInput.vue";

export default {
    components: {UiInput},
  props: {
    packageId: null,
  },
  data() {
    return {
        search: '',
    }
  },
  methods: {
    async fetch() {
      return await DispatchDocket.allByPackage(this.packageId, '')
    },
      pipeItems(items) {
          const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
          if (query.length) {
              return items.filter((dd) => {
                  return query.every((token) => {
                      return dd.tokens.includes(token);
                  })
              });
          }
          return items;
      },
  }
}
</script>
